import Resizer from "./Resizer";

export const resizeFile = (file, maxWidth = 1000, maxHeight = 1000, outputFormat = "jpeg", quality = 80, rotation = 0) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      maxWidth,
      maxHeight,
      outputFormat,
      quality,
      rotation,
      (uri) => {
        resolve(uri);
      },
      "file", // base64, blob or file
    );
  });





  